module.exports = __webpack_public_path__ + "img/d-title.f8b816c8.png";